module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/page/system/company_mgr.page.css
// module id = ./src/app/page/system/company_mgr.page.css
// module chunks = main